import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=3b246eb6&scoped=true&"
import script from "./NavButtons.vue?vue&type=script&lang=js&"
export * from "./NavButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=3b246eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b246eb6",
  null
  
)

export default component.exports